import { render } from "./VerificationPage.vue?vue&type=template&id=245cf696"
import script from "./VerificationPage.vue?vue&type=script&lang=js"
export * from "./VerificationPage.vue?vue&type=script&lang=js"

import "./VerificationPage.vue?vue&type=style&index=0&id=245cf696&lang=css"
/* custom blocks */
import block0 from "./VerificationPage.vue?vue&type=custom&index=0&blockType=button&class=send-button"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__